// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__bdcys","content":"Layout_content__Aw29B"};